import React from 'react';
import { object, bool, string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import Trigger from '../../shared/FirstMessagePopup/Trigger';
import { reportContactSellerClick } from '../../../utils/contactSeller';
import { ARROW_SIZE } from '../constants';

import './style.scss';

const ContactSellerBtn = (
    {
        showArrow,
        titleKey,
        mixpanelSourceComponent,
        bqSourceName
    },
    { biEvents }
) => {
    const onClick = () => reportContactSellerClick({
        biEvents,
        mixpanelSourceComponent,
        bqSourceName,
        metricKey: 'contact_seller.click'
    });

    return (
        <div className="contact-seller-wrapper">
            <Trigger className="btn-contact-seller" onClick={onClick}>
                <I18n k={titleKey}/>
                {showArrow &&
                    <Icon size={ARROW_SIZE}>{l_arrow_right}</Icon>
                }
            </Trigger>
        </div>
    );
};

ContactSellerBtn.propTypes = {
    showArrow: bool,
    titleKey: string,
    mixpanelSourceComponent: string,
    bqSourceName: string
};

ContactSellerBtn.contextTypes = {
    biEvents: object
};

export default ContactSellerBtn;
